import { render } from "./PublicationImage.vue?vue&type=template&id=42eaccc3&scoped=true"
import script from "./PublicationImage.vue?vue&type=script&lang=js"
export * from "./PublicationImage.vue?vue&type=script&lang=js"

import "./PublicationImage.vue?vue&type=style&index=0&id=42eaccc3&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42eaccc3"]])

export default __exports__